var map = {
	"./buildJobstreetLocalisation": 65789,
	"./buildJobstreetLocalisation.ts": 65789,
	"./en-id": 4995,
	"./en-id.ts": 4995,
	"./en-my": 63583,
	"./en-my.ts": 63583,
	"./en-ph": 57485,
	"./en-ph.ts": 57485,
	"./en-sg": 13805,
	"./en-sg.ts": 13805,
	"./id-id": 30630,
	"./id-id.ts": 30630,
	"./partners": 98787,
	"./partners.ts": 98787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15451;